// ✅ components/forms/TranslationKeyForm.tsx
import React from 'react'; 
import { Button, TextField } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { TranslationKeyReq } from '../types/language';

const schema = Yup.object().shape({
  translationKey: Yup.string().required('Required'),
});

export const TranslationKeyForm = ({ initialValues, onSubmit }: {
  initialValues: TranslationKeyReq;
  onSubmit: (values: TranslationKeyReq) => void;
}) => (
  <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={schema}>
    {({ values, handleChange }) => (
      <Form>
        <TextField
          name="translationKey"
          label="Translation Key"
          value={values.translationKey}
          onChange={handleChange}
          fullWidth
        />
        <Button type="submit" variant="contained" sx={{ mt: 2 }}>Save</Button>
      </Form>
    )}
  </Formik>
);